import { FrameStore, ModuleBase } from "@/modules/base";
import { Layer2Component } from "@/stellar-globe-components";
import { GridLayer } from '@hscmap/stellar-globe';
import { CreateElement } from "vue";
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';

@Component
export class GridLayerModule extends Mixins(ModuleBase) {
  get outlet() {
    return {
      overlayLayer: OverlayLayer,
    }
  }

  frameStore() {
    return {
      show: true,
    }
  }
}

@Component
class OverlayLayer extends Vue {
  @Prop({ required: true })
  frameStore!: FrameStore<typeof GridLayerModule>

  render(h: CreateElement) {
    return this.frameStore.show ? h(Layer2Component(GridLayer)) : undefined
  }
}
